/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { Container } from '@adobe-commerce/elsie/lib';
import { SuccessNotificationForm } from '@/auth/components';
import { SuccessNotificationProps } from '@/auth/types';

export const SuccessNotification: Container<SuccessNotificationProps> = ({
  formSize = 'default',
  slots,
  className,
  labels,
}) => {
  return (
    <div className="auth-success-notification">
      <SuccessNotificationForm
        formSize={formSize}
        className={className}
        slots={slots}
        labels={labels}
      />
    </div>
  );
};
